export default __webpack_public_path__ + "static/media/af1.382013d6.jpg";